var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('p',{staticClass:"ds-text-base normal text-gray-500"},[_vm._v(" Start typing an athlete, club or high school name… ")])])
}]

export { render, staticRenderFns }